import { FormEvent, useRef, useState } from 'react';
import { httpStatus, integrationErrorMessage, platformApi } from './client';

// Coupon requests happen only on an explicit form submission, never in the load runner.
export function LiveInsertCoupons({ seq, liveStatus }: { seq: number; liveStatus: string }) {
  const [amount, setAmount] = useState('1000');
  const [tickets, setTickets] = useState('1');
  const [busy, setBusy] = useState('');
  const [error, setError] = useState('');
  const [message, setMessage] = useState('');
  const requests = useRef<Record<string, { id: string; value: number }>>({});
  const lock = useRef(false);
  const grant = async (event: FormEvent, type: 'discount' | 'cancel') => {
    event.preventDefault(); if (lock.current) return;
    const value = Number(type === 'discount' ? amount : tickets);
    if (!Number.isSafeInteger(value) || value < 1 || value > (type === 'discount' ? 2147483647 : 100)) return;
    lock.current = true; setBusy(type); setError(''); setMessage('');
    const request = requests.current[type] ??= { id: crypto.randomUUID(), value };
    try {
      const { data } = await platformApi.post(`/live-insert/lives/${seq}/${type}-coupon`, {
        live_seq: seq, request_id: request.id, ...(type === 'discount' ? { amount: request.value } : { ticket_count: request.value }),
      });
      const count = type === 'discount' ? data?.granted_count : data?.participant_count;
      if (!Number.isSafeInteger(count) || count < 0) throw new Error('쿠폰 지급 응답을 확인하지 못했습니다.');
      setMessage(type === 'discount' ? `${count}명에게 ${request.value.toLocaleString()}원 할인 쿠폰을 지급했습니다.${data.already_granted_count > 0 ? ` 기존 지급 ${data.already_granted_count}명은 중복 제외했습니다.` : ''}`
        : `${count}명에게 취소 쿠폰을 ${request.value}장씩 지급했습니다.`);
      delete requests.current[type];
    } catch (failure) {
      const status = httpStatus(failure);
      if (status && status < 500 && status !== 409) delete requests.current[type];
      setError(integrationErrorMessage(failure));
    } finally { lock.current = false; setBusy(''); }
  };
  return <section className="li-coupons" aria-label="쿠폰 수동 지급">
    <h3>쿠폰 지급</h3><p>지급 시점에 접속 중인 회원에게 지급합니다.</p>
    <div className="li-coupon-forms">
      <form onSubmit={event => void grant(event, 'discount')}>
        <label>할인 쿠폰 금액 (원)<input type="number" min="1" max="2147483647" required value={amount} disabled={Boolean(busy) || Boolean(requests.current.discount)} onChange={event => setAmount(event.target.value)} /></label>
        <button type="submit" className="pa-button" disabled={Boolean(busy)}>{busy === 'discount' ? '지급 중…' : requests.current.discount ? '할인 쿠폰 지급 결과 확인' : '할인 쿠폰 지급'}</button>
      </form>
      <form onSubmit={event => void grant(event, 'cancel')}>
        <label>취소 쿠폰 수 (장)<input type="number" min="1" max="100" required value={tickets} disabled={Boolean(busy) || Boolean(requests.current.cancel)} onChange={event => setTickets(event.target.value)} /></label>
        <button type="submit" className="pa-button" disabled={Boolean(busy) || !['리허설', '방송중'].includes(liveStatus)}>{busy === 'cancel' ? '지급 중…' : requests.current.cancel ? '취소 쿠폰 지급 결과 확인' : '취소 쿠폰 지급'}</button>
      </form>
    </div>
    {!['리허설', '방송중'].includes(liveStatus) && <p>취소 쿠폰 추가 지급은 리허설·방송 중에 사용할 수 있습니다.</p>}
    {error && <p className="li-error" role="alert">{error}</p>}{message && <p className="li-coupon-success" role="status">{message}</p>}
  </section>;
}
